/**
 * @generated SignedSource<<aa6a155db23a8bab5e2a76e41692e658>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RenderChildRowsComp_rank$data = {
  readonly aliases?: ReadonlyArray<string> | null | undefined;
  readonly fieldId: string | null | undefined;
  readonly jqlTerm: string;
  readonly " $fragmentType": "RenderChildRowsComp_rank";
};
export type RenderChildRowsComp_rank$key = {
  readonly " $data"?: RenderChildRowsComp_rank$data;
  readonly " $fragmentSpreads": FragmentRefs<"RenderChildRowsComp_rank">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "RenderChildRowsComp_rank",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "ScalarField",
      "name": "jqlTerm"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "aliases"
        }
      ]
    }
  ],
  "type": "JiraJqlFieldWithAliases"
};

(node as any).hash = "f7566d909ef8ff6dbcaf39bc2e7997a7";

export default node;
